import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './i18n/en.json';
import es from './i18n/es.json';

const supportedLanguages = ["es", "en"];

function getInitialLanguage() {
  if (typeof window === "undefined") return "es";

  const stored = window.localStorage.getItem("prel-language");
  if (stored && supportedLanguages.includes(stored)) return stored;

  const browser = (window.navigator.language || "").toLowerCase();
  if (browser.startsWith("en")) return "en";

  return "es";
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'es',
    supportedLngs: supportedLanguages,
    interpolation: {
      escapeValue: false, // React ya hace el escape
    },
  });

export default i18n;
